// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-transparent[data-v-4f96ef57]{border-color:transparent!important;background-color:transparent!important}.border-danger-select[data-v-4f96ef57]  .vs__dropdown-toggle{border-color:red!important}", ""]);
// Exports
module.exports = exports;
